
function getTwitterText(content) {
  const twitterTextWrapper = document.createElement('DIV');
  twitterTextWrapper.innerHTML = content;
  let twitterText = twitterTextWrapper.innerText;

  return encodeURI(twitterText.substring(0,60));
}

export function addQuote(quote) {
  

  const quoteContainer = document.querySelector('.row-quotes .et_pb_code_inner');
  const quoteElem = document.createElement('DIV');
  quoteElem.classList.add('et_pb_module');
  quoteElem.classList.add('et_pb_blurb');
  quoteElem.innerHTML = `
    <div style="border-color: ${quote.crb_border_color || '#000000'}">		  
      <div class="et_pb_blurb_content">
        <div class="et_pb_blurb_container">
          <h4 class="et_pb_module_header"><span><a href="${quote.link}">${quote.title.rendered}</a></span></h4>
          <div class="et_pb_blurb_description"><a href="${quote.link}">${quote.content.rendered}</a></div>
          <div class="quote-share">
            <p>Share:</p>
            <ul class="et-social-icons">
              <li class="et-social-icon et-social-twitter">
                <a href="https://twitter.com/intent/tweet?url=${quote.link}&amp;text=${getTwitterText(quote.content.rendered)}&amp;via=FuturistsWorld" target="_blank" class="icon">
                  <span>Twitter</span>
                </a>
              </li>
              <li class="et-social-icon et-social-facebook">
                <a href="https://www.facebook.com/sharer/sharer.php?u=${quote.link}" target="_blank" class="icon">
                  <span>Facebook</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  `;

  quoteContainer.appendChild(quoteElem);
}


// WEBPACK FOOTER //
// ./src/js/utils/addQuote.js